import Alert from './alert/Alert.vue'
import AlertCancel from './alert/AlertCancel.vue'
import AlertCode from './alert/AlertCode.vue'
import AlertCogTooth from './alert/AlertCogTooth.vue'
import AlertDanger from './alert/AlertDanger.vue'
import AlertInfo from './alert/AlertInfo.vue'
import AlertSuccess from './alert/AlertSuccess.vue'
import AlertWarning from './alert/AlertWarning.vue'
import Button from './button/Button.vue'
import ButtonCancel from './button/ButtonCancel.vue'
import ButtonClose from './button/ButtonClose.vue'
import ButtonConfirm from './button/ButtonConfirm.vue'
import ButtonCopy from './button/ButtonCopy.vue'
import ButtonGroup from './button/ButtonGroup.vue'
import ButtonLink from './button/ButtonLink.vue'
import ButtonNew from './button/ButtonNew.vue'
import ButtonPlus from './button/ButtonPlus.vue'
import ButtonPrint from './button/ButtonPrint.vue'
import ButtonReturn from './button/ButtonReturn.vue'
import ButtonUpload from './button/ButtonUpload.vue'
import ButtonLockOpen from './button/ButtonLockOpen.vue'
import ButtonDefault from './button/ButtonDefault.vue'
import ButtonShare from './button/ButtonShare.vue'
import ButtonTrash from './button/ButtonTrash.vue'
import InputSearch from './filtro/InputSearch.vue'
import FiltroSelect from './filtro/FiltroSelect.vue'
import ButtonEdit from './button/ButtonEdit.vue'
import ButtonLoad from './button/ButtonLoad.vue'
import ButtonExport from './button/ButtonExport.vue'
import HeaderForm from './header/HeaderForm.vue'
import HeaderPage from './header/HeaderPage.vue'
import Icon from './icon/Icon.vue'
import IconArrowLeft from './icon/IconArrowLeft.vue'
import IconArrowDown from './icon/IconArrowDown.vue'
import IconCancel from './icon/IconCancel.vue'
import IconCheck from './icon/IconCheck.vue'
import IconClose from './icon/IconClose.vue'
import IconCode from './icon/IconCode.vue'
import IconCogTooth from './icon/IconCogTooth.vue'
import IconCopy from './icon/IconCopy.vue'
import IconEscala from './icon/IconEscala.vue'
import IconInfo from './icon/IconInfo.vue'
import IconLink from './icon/IconLink.vue'
import IconOrdemMissao from './icon/IconOrdemMissao.vue'
import IconLicenca from './icon/IconLicencas.vue'
import IconPlus from './icon/IconPlus.vue'
import IconPrint from './icon/IconPrint.vue'
import IconSolicitacao from './icon/IconSolicitacao.vue'
import IconUpload from './icon/IconUpload.vue'
import IconShare from './icon/IconShare.vue'
import IconTrash from './icon/IconTrash.vue'
import IconWarning from './icon/IconWarning.vue'
import IconPencil from './icon/IconPencil.vue'
import IconArrowPath from './icon/IconArrowPath.vue'
import IconLockOpen from './icon/IconLockOpen.vue'
import IconArrowEndRectangle from './icon/IconArrowEndRectangle.vue'
import IconExportDoc from './icon/IconExportDoc.vue'
import IconDespacho from './icon/IconDespacho.vue'
import IconMotor from './icon/IconMotor.vue'
import Column from './layout/Column.vue'
import Container from './layout/Container.vue'
import Divider from './layout/Divider.vue'
import Row from './layout/Row.vue'
import Section from './layout/Section.vue'
import IconOrderBy from './icon/IconOrderBy.vue'
export default {
	components: {
		Alert,
		AlertCancel,
		AlertCode,
		AlertCogTooth,
		AlertInfo,
		AlertSuccess,
		AlertWarning,
		AlertDanger,
		Button,
		ButtonCancel,
		ButtonClose,
		ButtonConfirm,
		ButtonCopy,
		ButtonGroup,
		ButtonLink,
		ButtonNew,
		ButtonPlus,
		ButtonPrint,
		ButtonReturn,
		ButtonUpload,
		ButtonLockOpen,
		ButtonDefault,
		ButtonShare,
		ButtonEdit,
		ButtonExport,
		ButtonTrash,
		IconOrdemMissao,
		IconLicenca, 
		InputSearch,
		FiltroSelect,
		ButtonLoad,
		HeaderForm,
		HeaderPage,
		Icon,
		IconArrowDown,
		IconArrowLeft,
		IconCancel,
		IconCheck,
		IconCode,
		IconClose,
		IconCogTooth,
		IconCopy,
		IconEscala,
		IconInfo,
		IconLink,
		IconPlus,
		IconPrint,
		IconSolicitacao,
		IconUpload,
		IconWarning,
		IconPencil,
		IconArrowPath,
		IconOrderBy,
		IconLockOpen,
		IconArrowEndRectangle,
		IconExportDoc,
		IconDespacho,
		IconMotor,
		IconShare,
		IconTrash,
		Column,
		Container,
		Divider,
		Row,
		Section
	}
}
